module.exports = __webpack_public_path__ + "img/lv.f3c1274d.svg";